module.exports = __webpack_public_path__ + "img/fjm-logo-bleu.c47445ac.svg";